import type { ModelRecordPayment } from '@app/api/Records/types';
import type {
  ConfirmResult,
  UnsavedConfirmType,
} from '@app/hooks/useNewUnsavedData';
import type { Warnings } from '@app/services/rtkQuery/Records/types';

import type { MenuProps } from 'antd';
import type { ItemType, MenuItemType } from 'antd/es/menu/interface';
import type { FC } from 'react';

export interface SidebarProps {
  disabled?: boolean;
  tab: MenuTabEnum;
  onSelectTab(key: MenuTabEnum): void;
}

export enum MenuTabEnum {
  RecordDetails = 'record-details',
  RecordPayment = 'record-payment',
  RecordHistory = 'record-history',
  ClientData = 'client-data',
  ClientCard = 'client-card',
  VisitsHistory = 'visits-history',
  TechnologicalMap = 'technological-map',
  MedicalCard = 'medical-card',
}

export interface UseRecordModalEffectsProps {
  initTab(): void;
  skipTab(): void;
}

export type MenuItemInput = {
  label: React.ReactNode;
  key: React.Key;
  icon?: React.ReactNode;
  children?: ItemType<MenuItemType>[];
  type?: 'group';
  disabled?: boolean;
  dataTestId?: string;
};
export type MenuItemProps = Required<MenuProps>['items'][number];

export interface ContentProps {
  onCancel(): void;
  onSelectTab(key: MenuTabEnum): void;
  confirmUnsavedData: UnsavedConfirmType;
  confirmWarnings: (actualWarnings?: Warnings[]) => Promise<ConfirmResult>;
}

export type ContentPropsType = FC<ContentProps>;

export type HandlePayByYouKassaProps = Pick<
  ModelRecordPayment,
  'Amount' | 'PaymentMethod'
> & {
  IsNeedToCreatePayment: boolean;
  ClientPaymentId?: number;
  IsNeedToCreateLink?: boolean;
  PaymentAccountId?: number;
};
